import { GoogleAuthProvider } from "firebase/auth";
import FirebaseAuthService from "../firebase-service/FirebaseAuthService";
import FirebaseFirestoreService from "../firebase-service/FirebaseFirestoreService";
import { updateUserRedux } from "../actions/user.actions";
import { updateFormDataRedux } from "../actions/formData.actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [textError, setTextError] = useState("");
  const registerUser = (payload) => {
    dispatch(updateUserRedux(payload));
  };

  const loginFct = () => {
    setIsLoading(true);
    FirebaseAuthService.loginWithGoogle()
      .then((result) => {
        setIsLoading(false);
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const { accessToken, displayName, email, photoURL } = result.user;
        // IdP data available using getAdditionalUserInfo(result)
        registerUser({ accessToken, displayName, email, photoURL, token });
        const queries = [
          {
            field: "uid",
            condition: "==",
            value: result?.user.uid,
          },
        ];

        if (result?.user) {
          FirebaseFirestoreService.readDocuments({
            collectionName: "formDataCollec",
            queries: queries,
          }).then((responseUser) => {
            if (responseUser?.length === 0) {
              FirebaseFirestoreService.createDocument(
                "formDataCollec",
                result?.user.uid,
                result?.user.displayName,
                result?.user.email
              )
                .then((docRef) => {
                  FirebaseFirestoreService.readDocuments({
                    collectionName: "formDataCollec",
                    queries: queries,
                  })
                    .then((data) => {
                      dispatch(updateFormDataRedux(data[0]));
                      return navigate("/home#newQuestion");
                    })
                    .catch((error) => {
                      console.log(error, " une erreur c'est produite");
                    });
                })
                .catch((error) => {
                  console.log("error during creation doc: ", error);
                });
            } else {
              dispatch(updateFormDataRedux(responseUser[0]));
              return navigate("/home#newQuestion");
            }
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        // Handle Errors here.
        //const errorCode = error.code;
        //const errorMessage = error.message;
        // The email of the user's account used.
        //const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
        console.log("erreur code: ", error, " error : ", credential);
        setTextError(error.message);
      });
  };
  return (
    <>
      {isLoading ? (
        <div className="flex flex-col h-screen justify-center items-center">
          <img
            alt="logo Ajiratomo"
            className="w-[200px] animate-bounce"
            src="/image/work-items.png"
          />
          <h2>Chargement ...</h2>
        </div>
      ) : (
        <div className="flex flex-col h-screen justify-center items-center">
          <div className="w-[200px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row justify-between items-center">
                <img
                  alt="logo Ajiratomo"
                  className="w-[42px]"
                  src="/image/robot_succeed.png"
                />
                <h1 className="text-md font-bold">Ajiratomo</h1>
              </div>

              <div className="flex flex-row">
                <img
                  className="w-[42px]"
                  src="/icons/contact-video.svg"
                  alt="nous contacter"
                />
              </div>
            </div>
            <p> Analyser votre besoin</p>
            <img
              alt="activités sur Toulouse"
              className="mask mask-squircle my-4 h-[200px] object-cover"
              src="/image/work_environment.png"
            />
          </div>
          <button
            className="btn btn-neutral"
            onClick={() => {
              loginFct();
            }}
          >
            <svg
              width="32px"
              height="32px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
            >
              <path
                fill="#4285F4"
                d="M14.9 8.161c0-.476-.039-.954-.121-1.422h-6.64v2.695h3.802a3.24 3.24 0 01-1.407 2.127v1.75h2.269c1.332-1.22 2.097-3.02 2.097-5.15z"
              />
              <path
                fill="#34A853"
                d="M8.14 15c1.898 0 3.499-.62 4.665-1.69l-2.268-1.749c-.631.427-1.446.669-2.395.669-1.836 0-3.393-1.232-3.952-2.888H1.85v1.803A7.044 7.044 0 008.14 15z"
              />
              <path
                fill="#FBBC04"
                d="M4.187 9.342a4.17 4.17 0 010-2.68V4.859H1.849a6.97 6.97 0 000 6.286l2.338-1.803z"
              />
              <path
                fill="#EA4335"
                d="M8.14 3.77a3.837 3.837 0 012.7 1.05l2.01-1.999a6.786 6.786 0 00-4.71-1.82 7.042 7.042 0 00-6.29 3.858L4.186 6.66c.556-1.658 2.116-2.89 3.952-2.89z"
              />
            </svg>
            Se connecter
          </button>
          <p className="text-md">{textError}</p>
        </div>
      )}
    </>
  );
};
